import React, { Component } from "react";
import { Modal, Row, Col } from "antd";
import "./Modal.css";
import Caixa1 from '../imagens/RelCaixa/Caixa1.png';
import Caixa2 from '../imagens/RelCaixa/Caixa2.png';
import Caixa3 from '../imagens/RelCaixa/Caixa3.png';
import Caixa4 from '../imagens/RelCaixa/Caixa4.png';
import Caixa5 from '../imagens/RelCaixa/Caixa5.png';
import Caixa6 from '../imagens/RelCaixa/Caixa6.png';
import Caixa7 from '../imagens/RelCaixa/Caixa7.png';
import Caixa8 from '../imagens/RelCaixa/Caixa8.png';

export default class RelCaixa extends Component {

    render() {

        const { isOpen, onClose } = this.props;

        return (
            <Modal
                title="Como utilizar o relatório de Caixas"
                className="modal"
                visible={isOpen}
                destroyOnClose
                onCancel={onClose}
                footer={null}
                width="50%"
                style={{ top: 10 }}
            >
                <Row>
                    <Col xs={24}>
                        <p>Para acessar o relatório de Caixas:  </p>

                        <div className="image-wrapper">
                            <img className="img_smaller" src={Caixa1} alt="Caixa 1"/>
                        </div>

                        <div className="gray_bar"></div>

                        <div className="image-wrapper">
                            <img src={Caixa2} alt="Caixa 2"/>
                        </div>                        

                        <h3>No relatório de Caixas nós temos:</h3>
                        <ol>
                            <li>Filtros para buscar os lançamentos financeiros nos caixas.</li>
                            <li>Impressão dos lançamentos que estão na tabela.</li>
                            <li>Botão para fazer transferências de valor entre contas conrrentes.</li>
                            <li>Botão para abrir uma tela mostrando os caixas criados e onde o gestor pode cadastrar um novo caixa.</li>
                            <li>Informações dos totais dos caixas.</li>
                            <li>Tabela mostrando os lançamentos feitos na data especificada no filtro.</li>
                            <li>Paginação da tabela de lançamentos.</li>
                        </ol>

                        <div className="gray_bar"></div>

                        <h3>Como filtrar os Lançamentos financeiros</h3> 
                        <p>Para facilitar o gerenciamento dos caixas o gestor pode utilizar os filtros disponíveis no canto superior esquerdo da tabela.</p>

                        <div className="image-wrapper">
                            <img src={Caixa3} alt="Caixa 3"/>
                        </div>    
                        <div className="image-wrapper">
                            <img src={Caixa4} alt="Caixa 4"/>
                        </div>     

                        <div className="gray_bar"></div>  

                        <h3>Como fazer transferências de valores entre contas</h3>           
                        <p>Para fazer transferências de valores entre contas basta clicar no botão "Trnasferência"</p>

                        <div className="image-wrapper">
                            <img src={Caixa5} alt="Caixa 5"/>
                        </div>    
                        <div className="image-wrapper">
                            <img src={Caixa6} alt="Caixa 6"/>
                        </div>                           

                        <p>
                            Após preencher as informações corretamente e feito a transferência, um lançamento será feito para as contas financeiras de origem e destino 
                            para fazer o ajuste do saldo dessas contas. Para salvar o lançamento basta clicar em "Gravar". 
                        </p>

                        <div className="gray_bar"></div>  

                        <h3>Gerenciando Caixas</h3>      

                        <p>
                            Para gerenciar os caixas, basta clicar no botão "Caixa" para abrir a tela de controle dos caixas.    
                        </p>                  
                        <div className="image-wrapper">
                            <img src={Caixa7} alt="Caixa 7"/>
                        </div>   

                        <p>
                            Na tela de Caixas, o gestor poderá fechar um caixa utilizando as opções extras na tabela de caixas(1), ou excluir um caixa utilizando 
                            o botão da Lixeria(2), ou pode também criar um novo caixa colocando a data do caixa e a conta e depois clicando em Gravar(3). 
                            Lembrar que o caixa não pode ser excluído se houver movimentação financeira feita para ele. 
                        </p>  
                        <div className="image-wrapper">
                            <img src={Caixa8} alt="Caixa 8"/>
                        </div>                                             
                    </Col>
                </Row>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/tutoriais/RelCaixa.js